
import React from 'react'
import CheckBoxCircle from '../ui/CheckBoxCircle.jsx';
import { withRouter, Link } from 'react-router'

const AdminUserRow = ({ router, user, handleToggleAdmin }) => {
  const go = ()=>{
    router.push('/profile/'+user.uid)
  }

  return (
      <li onClick={go} className="row" >
        <div className="avatar link">
          <img src={user.picture} alt="Profile" />
        </div>
        <div className="md-subhead row-content" >
          {user.name}<br />
          <div className="md-body-2">
            {user.allPractices ? (user.allPractices.map((practice, i )=> (
                <span key={`practice-${practice._id}-${user._id}`}>
                    {i? ', ' : ''}
                    <Link to={`/practice/${practice.slug}`}>{practice.name}</Link>
                </span>
            ))) : null}
          </div>
        </div>
        <div onClick={(e) => { e.stopPropagation(); handleToggleAdmin(user) }} className="confirm-user">
            <CheckBoxCircle on={user.admin} ></CheckBoxCircle>
            <label className="md-caption">Admin</label>
        </div>
      </li>
    )
}

export default withRouter(AdminUserRow);



// WEBPACK FOOTER //
// ./src/components/admin/AdminUserRow.jsx